import { render } from "./DirectVideoPage.vue.js?vue&type=template&id=633a9076&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectVideoPage.vue?vue&type=template&id=633a9076&scoped=true"
import script from "./DirectVideoPage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectVideoPage.vue?vue&type=script&lang=js"
export * from "./DirectVideoPage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectVideoPage.vue?vue&type=script&lang=js"

import "./DirectVideoPage.vue.scss?vue&type=style&index=0&id=633a9076&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectVideoPage.vue?vue&type=style&index=0&id=633a9076&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633a9076"],['__file',"src/Web/scripts/pages/community/DirectVideoPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "633a9076"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('633a9076', __exports__)) {
    api.reload('633a9076', __exports__)
  }
  
  module.hot.accept("./DirectVideoPage.vue.js?vue&type=template&id=633a9076&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DirectVideoPage.vue?vue&type=template&id=633a9076&scoped=true", () => {
    api.rerender('633a9076', render)
  })

}


export default __exports__